import smbUtils from "./smbUtils";

const dataLayerPush = elm => {
  if (!smbUtils.isWithGa()) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(elm);
};

const utils = {
  sendEvent: e => {
    dataLayerPush({
      event: e,
    });
  },
};

export default utils;
